import React from "react";
import PageHeader from "../components/PageHeader";

export default function NCPCRNews() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "NCPCR in News", active: true },
  ];

  const documents = [
    {
      title: "Bench Organized at District Bharuch, Gujarat for redressal of complaints related to violation of child rights on 26.09.2022",
      size: "463.76 KB",
      date: "28-09-22",
      link: "#",
    },
    {
      title: "Bench Organized at District Harda, Madhya Pradesh for redressal of complaints related to violation of child rights on 24.09.2022",
      size: "1.15 MB",
      date: "27-09-22",
      link: "#",
    },
    {
      title: "Bench Organized at District Khargon , Madhya Pradesh for redressal of complaints related to violation of child rights on 23.09.2022",
      size: "629.18 KB",
      date: "27-09-22",
      link: "#",
    },
    {
      title: "Bench Organized at District Dang, Gujarat for redressal of complaints related to violation of child rights on 16.09.2022",
      size: "268.74 KB",
      date: "17-09-22",
      link: "#",
    },
    {
      title: "Bench Organized at District Dhar, Madhya Pradesh for redressal of complaints related to violation of child rights",
      size: "773.30 KB",
      date: "14-09-22",
      link: "#",
    },
    {
      title: "Adoption of children will be easy under the newly amended Juvenile Justice (Care and Protection of Children) Act, which came into force from September 1, 2022.",
      size: "593.64 KB",
      date: "14-09-22",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="NCPCR in News (NCPCR, Govt. of India)" breadcrumbs={breadcrumbs} />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            NCPCR in News
          </h2>

          <div className="position-relative">
            {/* Center vertical line */}
            <div
              className="position-absolute top-0 start-50 translate-middle-x bg-primary"
              style={{ width: "4px", height: "100%", borderRadius: "2px" }}
            ></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {documents.map((doc, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{doc.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold mb-2">{doc.title}</h5>
                      <p className="text-secondary mb-3">{doc.size}</p>
                      <a
                        href={doc.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
